import Api from './Api';

class UsuarioService {
  constructor() {
    this.$api = Api;
  }

  async findAll(filters) {
    return this.$api.get('/usuarios', filters);
  }

  async save(data) {
    const id = data.id || 0;

    if (id === 0) {
      return this.$api.post('/usuario', data);
    }

    return this.$api.put(`/usuario/${id}`, data);
  }

  async findById(id) {
    return this.$api.get(`/usuario/${id}`);
  }

  async remove(id) {
    return this.$api.delete(`/usuario/${id}`);
  }
}

export default new UsuarioService();
